import { Breakpoints, BreakpointWrapper, Layout } from '@volkswagen-onehub/components-core';
import { gsap } from 'gsap';
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { CustomBreakpoints } from '../../helpers/breakpoints';
import { CarlineWithOfertas } from '../../services/ofertas-service/models/ofertas';
import { OfertaCardsContainerDesktop } from '../oferta-card/desktop/oferta-cards-container-desktop';
import { ModelCarrousel } from './model-carrousel/model-carrousel';

const CardContainer = styled.div<{ hasOneCarline: boolean }>`
	position: relative;
	left: 0;
	width: 100vw;

	@media screen and (min-width: 1200px) {
		min-height: ${(props) => props.hasOneCarline && '50vh'};
		& > div {
			min-height: ${(props) => (props.hasOneCarline ? '50vh ' : '100%')};
			align-content: center;
		}
	}
`;

export const ModelFrameContent = styled.div<{ hasOneCarline: boolean }>`
	width: 100%;
	height: ${(props) => (props.hasOneCarline ? 'auto' : '100vh')};
	overflow: hidden;
	min-height: ${(props) => props.hasOneCarline && 'fit-content'};

	@media screen and (min-width: 1200px) {
		display: flex;
		align-items: center;
		justify-content: space-evenly;
		position: relative;
	}
`;

export const ModelFrame = React.forwardRef<
	HTMLDivElement,
	{
		carline: CarlineWithOfertas;
		hasOneCarline: boolean;
	}
>(({ carline, hasOneCarline }, ref) => {
	const contentRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const animateRef = ref && 'current' in ref ? ref.current : contentRef.current;

		if (animateRef) {
			gsap.killTweensOf(animateRef);
			gsap.fromTo(
				animateRef,
				{ opacity: 0, y: -50 },
				{
					opacity: 1,
					y: 0,
					duration: 0.6,
					ease: 'power2.inOut',
					overwrite: 'auto',
				},
			);
		}
	}, [carline, ref]);

	return (
		<ModelFrameContent
			hasOneCarline={hasOneCarline}
			className={`ofertas__model-frame-${carline.name}`}
			ref={contentRef}
		>
			{/* Desktop >960 */}
			<ModelCarrousel />

			{/* Desktop >1200 */}
			<BreakpointWrapper min={CustomBreakpoints.DESKTOP} data-testid="model-frame__breakpoint-wrapper-desktop">
				<CardContainer hasOneCarline={hasOneCarline} className="model-frame__card-container-desktop">
					<Layout
						data-testid="model-frame__layout-ofertas-card-desktop"
						appearance={{
							[Breakpoints.default]: [{ name: 'a', columns: 24 }],
							[Breakpoints.b960]: [
								{ name: '.', columns: 1 },
								{ name: 'a', columns: 22 },
								{ name: '.', columns: 1 },
							],
							[CustomBreakpoints.DESKTOP]: [
								{ name: '.', columns: 14 },
								{ name: 'a', columns: 9 },
								{ name: '.', columns: 1 },
							],
							[Breakpoints.b1920]: [
								{ name: '.', columns: 15 },
								{ name: 'a', columns: 8 },
								{ name: '.', columns: 1 },
							],
							[Breakpoints.b2560]: [
								{ name: '.', columns: 16 },
								{ name: 'a', columns: 6 },
								{ name: '.', columns: 1 },
							],
						}}
					>
						<OfertaCardsContainerDesktop className="model-frame__ofertas-card-container-desktop" carline={carline} />
					</Layout>
				</CardContainer>
			</BreakpointWrapper>
		</ModelFrameContent>
	);
});
